export const ORDER_PAYMENT_STATUS = {
  NEW: 'New',
  PROCESSING: 'Processing',
  PENDING: 'Pending',
  FAILED: 'Failed',
  SUCCESS: 'Success',
  CANCELED: 'Canceled'
}

export const PAYMENT_NEW = ORDER_PAYMENT_STATUS.NEW
export const PAYMENT_PROCESSING = ORDER_PAYMENT_STATUS.PROCESSING
export const PAYMENT_PENDING = ORDER_PAYMENT_STATUS.PENDING
export const PAYMENT_FAILED = ORDER_PAYMENT_STATUS.FAILED
export const PAYMENT_SUCCESS = ORDER_PAYMENT_STATUS.SUCCESS
export const PAYMENT_CANCELED = ORDER_PAYMENT_STATUS.CANCELED

export const ORDER_PAYMENT_STATUS_RETRY_ORDER_DETAIL = [
  ORDER_PAYMENT_STATUS.NEW,
  ORDER_PAYMENT_STATUS.PROCESSING,
  ORDER_PAYMENT_STATUS.PENDING
]

export const ORDER_PAYMENT_STATUS_TO_TEXT = {
  [ORDER_PAYMENT_STATUS.NEW]: 'Chưa thanh toán',
  [ORDER_PAYMENT_STATUS.PROCESSING]: 'Đang xử lý',
  [ORDER_PAYMENT_STATUS.PENDING]: 'Đang chờ',
  [ORDER_PAYMENT_STATUS.FAILED]: 'Thanh toán thất bại',
  [ORDER_PAYMENT_STATUS.SUCCESS]: 'Đã thanh toán',
  [ORDER_PAYMENT_STATUS.CANCELED]: 'Đã hủy'
}

export const ORDER_PAYMENT_STATUS_COLOR = [
  { value: undefined },
  { value: ORDER_PAYMENT_STATUS.NEW, color: '#FF1001' },
  { value: ORDER_PAYMENT_STATUS.PROCESSING, color: '#0d6efd' },
  { value: ORDER_PAYMENT_STATUS.PENDING, color: '#ffc107' },
  { value: ORDER_PAYMENT_STATUS.FAILED, color: '#ff6500' },
  { value: ORDER_PAYMENT_STATUS.SUCCESS, color: '#34aa44' },
  { value: ORDER_PAYMENT_STATUS.CANCELED, color: '#848484' }
]
